import { render, staticRenderFns } from "./auditStaffManageList.vue?vue&type=template&id=1b146ea2&scoped=true"
import script from "./auditStaffManageList.vue?vue&type=script&lang=js"
export * from "./auditStaffManageList.vue?vue&type=script&lang=js"
import style0 from "./auditStaffManageList.vue?vue&type=style&index=0&id=1b146ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b146ea2",
  null
  
)

export default component.exports